import { Fragment } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import 'react-tooltip/dist/react-tooltip.css';

const SmallInfoSymbol = ({
  id = 'info-tooltip',
  tooltipText = '',
  delay = '',
  place = 'top',
  size = 16,
  color = '#888',
}) => {
  return (
    <Fragment>
      <button
        data-tooltip-delay-show={delay}
        data-tooltip-id={id}
        type="button"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'pointer',
          border: 'none',
          background: 'none',
          padding: 0,
        }}
      >
        <AiOutlineInfoCircle size={size} color={color} />
      </button>
      <ReactTooltip className="custom-tooltip" id={id} place={place}>
        {typeof tooltipText === 'string'
          ? tooltipText
          : JSON.stringify(tooltipText)}
      </ReactTooltip>
    </Fragment>
  );
};

export default SmallInfoSymbol;
